<script>
import Banner from '../components/PageBanner';
import Title from '../components/PageTitle';
import Tab from '../components/PageTab';
import TabMenu from '../components/PageTabMenu';
import Footer from '../components/Footer';


export default {
  name: 'PageParams',
  components :{
    Banner,
    Title,
    Tab,
    TabMenu,
    Footer,
  },
  mounted(){
    var currentUrl = window.location.pathname;
    if(currentUrl === "/params/"){
      this.$router.push({ name: 'Temps'}) //Page par défaut tout en gardant le surligne de "Paramètres" dans le menu quelque soit le children
    }
  }
}
</script>

<template>
    <div class="page-main">
      <Banner bannerImage="bannerParams" hasAvatar=0 />
      <Title title="Paramètres" />

      <TabMenu item1=100>
        <template v-slot:body>
          <!-- <Tab text="Mon agence"  :route= "{name: 'Agence'}" customWidth=150 /> -->
          <Tab text="Temps passés"  :route= "{name: 'Temps'}" customWidth=150 />
          <Tab text="Listes"  :route= "{name: 'Listes'}" customWidth=150 />
        </template>
      </TabMenu>

      <div class="page-main-container">
        <router-view></router-view>
      </div>

      <Footer />
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

@include page-main;

</style>
